export const STEPPER_STEPS = [
  'Discovery',
  'Planning',
  'Design',
  'Prototyping',
  'Development',
  'Testing',
  'Launch',
  'Maintenance',
];

export const DEFAULT_PROGRESS_PERCENT = 50;
